import React, { useEffect } from "react";
import Link from "next/link";
import AOS from "aos";
import "aos/dist/aos.css";
import Head from "next/head";
import Image from "next/image";
import styles from "../../styles/Home.module.css";
import questions from "../../images/undraw_Online_test_re_kyfx.png";
import investment from "../../images/undraw_Success_factors_re_ce93.png";
import explore from "../../images/undraw_Progress_indicator_re_4o4n.png";
import decision from "../../images/undraw_Up_to_date_re_nqid.png";
import Footer from "../../component/footer";
import CallToAction from "../../component/callToAction";
import SuburbFinderFunnel from "../funnel";

export default function SuburbFinder() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <Head>
        <title>Discover Ideal Suburbs with SuburbFinder</title>
        <link
          rel="canonical"
          href="https://abodefinder.com.au/suburb-finder/"
        ></link>
        <meta
          property="og:title"
          content="Discover Ideal Suburbs with SuburbFinder"
        />
        <meta
          property="og:description"
          content="Find the perfect suburb for your next property investment with SuburbFinder. Get customised recommendations based on your budget, public transport needs, and school preferences."
        />
        <meta property="og:image" content="../images/1.png" />
        <meta
          property="og:url"
          content="https://abodefinder.com.au/suburb-finder/"
        />
        <meta
          name="description"
          content="Find the perfect suburb for your next property investment with SuburbFinder. Get customised recommendations based on your budget, public transport needs, and school preferences."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
      </Head>
      <main className={styles.firstMainSuburb}>
        <h1 className={styles.mainp}>
          The Ultimate Suburb Finder for Property Investors
        </h1>
        <h2 className={styles.mainp1}>
          Discover Your Perfect Suburb with SuburbFinder
        </h2>
        <div className={styles.FuneelIndex}>
          <SuburbFinderFunnel />
        </div>
      </main>
      <CallToAction />
      <section className={styles.suburbSection}>
        <div className={styles.suburbFinderText}>
          <h3>How is work?</h3>
          <p>
            SuburbFinder is a powerful platform designed to help you find your
            ideal suburb for property investment. Here's how it works
          </p>
        </div>

        <div className={styles.suburbBoxRow} data-aos="fade-down">
          <div className={styles.suburbFinderTextBox}>
            <div className={styles.suburbBox}>
              <h4>Answer a few questions</h4>
              <p>
                To get started, simply answer a few questions about your
                investment preferences, including your budget, preferred state,
                public transport needs, and school type. Based on your answers,
                our platform will provide you with a list of suburbs that meet
                your investment criteria.
              </p>
            </div>
            <div className={styles.suburbCircleNumber}>1</div>
          </div>
          <Image
            className={styles.suburbFinderImg}
            src={questions}
            alt="questions"
          />
        </div>

        <div className={styles.suburbBoxRowTwo} data-aos="fade-down">
          <Image
            className={styles.suburbFinderImg}
            src={investment}
            alt="investment"
          />
          <div className={styles.suburbFinderTextBox}>
            <div className={styles.suburbCircleNumberTwo}>2</div>
            <div className={styles.suburbBoxTwo}>
              <h4>Choose your investment strategy</h4>
              <p>
                SuburbFinder offers two investment strategies: capital growth
                and cash flow. You can choose the strategy that aligns with your
                investment goals and our platform will provide you with a list
                of suburbs that meet your specific criteria.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.suburbBoxRow} data-aos="fade-down">
          <div className={styles.suburbFinderTextBox}>
            <div className={styles.suburbBox}>
              <h4>Explore your investment options</h4>
              <p>
                Once you've chosen your investment strategy, you can explore the
                investment opportunities available in each suburb. Our platform
                provides you with clear insights into the property market,
                including median house prices, rental yields, vacancy rates, and
                more.
              </p>
            </div>
            <div className={styles.suburbCircleNumber}>3</div>
          </div>
          <Image
            className={styles.suburbFinderImg}
            src={explore}
            alt="explore"
          />
        </div>

        <div className={styles.suburbBoxRowTwo} data-aos="fade-down">
          <Image
            className={styles.suburbFinderImg}
            src={decision}
            alt="decision"
          />
          <div className={styles.suburbFinderTextBox}>
            <div className={styles.suburbCircleNumberTwo}>4</div>
            <div className={styles.suburbBoxTwo}>
              <h4>Make an informed decision</h4>
              <p>
                With SuburbFinder, you can make an informed decision about your
                property investment. Our platform provides you with all the
                information you need to make a smart investment decision,
                including property prices, rental yields, and other key metrics.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.suburbFinderSeo}>
        <p>
          {" "}
          SuburbFinder is the ultimate platform for property investors looking
          to discover their dream suburb and make informed decisions about their
          investment. Our user-friendly and intuitive platform allows you to
          easily find the ideal suburb for your investment goals based on your
          budget, preferred state, public transport needs, and school type. With
          SuburbFinder, you can choose between a capital growth or cash flow
          strategy and we'll take care of the rest, providing you with clear
          insights into your investment options. Trust SuburbFinder as your
          ultimate partner in your property investment journey.
        </p>
        <div className={styles.buttons}>
          <Link className="btn-ab" href="/suburb-finder/">
            Start Now
          </Link>
        </div>
      </section>
      <Footer />
    </>
  );
}
